import FlightSearchApi from "@/services/FlightSearchApi";
import store from "../store";

export default {
  data() {
    return {
      loading: true
    };
  },
  submitPayment(params) {
    if (store.state.loading !== true) {
      store.commit("setLoading", true);
      return FlightSearchApi()
        .post("", params)
        .then(function(response) {
          if (typeof response.data === "object") {
            if (typeof response.data.error === "undefined") {
              if (
                response.data.bid !== undefined &&
                (
                  response.data.bid > 0 ||
                  response.data.bid == ""
                )
              ) {
                store.commit("setBID", response.data.bid);
                store.commit('setPaymentError','');
                store.commit("setFormComplete");
              }
              else if(response.data.skipped_payment)
              {
                store.commit('setPaymentError','');
                store.commit("setFormComplete");
              }
            } else {
              console.log("ERROR -> submitPayment: ", response.data.error);
              // store.commit("setComplete", false);
              store.commit("setPaymentError",response.data.error);
              // store.commit("setErrorState", [
              //   "Payment",
              //   response.data.error
              // ]);
            }
          } else {
            console.log("INVALID RESULT for submitPayment", response);
          }
        })
        .catch(function(error) {
          console.log("ERROR: ", error);
          // store.commit("setErrorState", [
          //   "Payment",
          //   "Payment Error. Please try again."
          // ]);
          store.commit("setComplete", false);
          store.commit('setPaymentError','Unable to process payment. Please try again or call 1.800.447.3247.');
        })
        .finally(function() {
          store.commit("setLoading", false);
        });
    } else {
      console.log("Already loading - abort payment request");
    }
  }
};
